import { atom } from "jotai";

export const setToScaleAtom = atom<any | null>(null);